import { render } from "./xtx-confirm.vue?vue&type=template&id=18637f4a&scoped=true"
import script from "./xtx-confirm.vue?vue&type=script&lang=js"
export * from "./xtx-confirm.vue?vue&type=script&lang=js"

import "./xtx-confirm.vue?vue&type=style&index=0&id=18637f4a&scoped=true&lang=less"

import exportComponent from "F:\\workspan\\java\\three_2\\ui\\hk-lottery-lhc-pc-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18637f4a"]])

export default __exports__